import { ItemService } from './../services/item.service';
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";
import { FormArray } from "@angular/forms";
import * as _ from 'lodash';

@Component({
    selector: 'basic-filter-editor',
    styles: [`
        .selectedSeparator {
            font-weight: bold;
            padding-left: 5px;
            padding-right: 5px;
        }
        .groupSeparator {
            padding-top: 20px;
            padding-bottom: 10px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    `],
    template: `
        <div>
            <mat-accordion>
                <span *ngFor="let filterStructure of basicFilterStructures.controls; let ind=index; let isLastGroup=last">
                    <mat-expansion-panel  
                                        #expPanel
                                        expanded="true"
                                        (opened)="tagGroupOpened.emit()"
                                        hideToggle="true">
                        <mat-expansion-panel-header [expandedHeight]="mlst.calcHeight || '100px'" [collapsedHeight]="mlst.calcHeight || '100px'">
                            <span style="padding-right: 20px;">{{conditionLabel(filterStructure.get('condition').value, ind)}}</span>
                            <span #mlst>
                            <mat-chip-list>
                                <span *ngFor="let tag of filterStructure.get('values').controls; let i=index; let isLastTag=last">
                                <mat-chip class="currentChip" [ngClass]="tagDefs[tag.get('type').value].cls">
                                    <span style="padding: 5px;">{{tagLabel(tag)}}</span>
                                    <small class="text-muted">
                                        <span *ngIf="!disabled">({{tagCountFor(tag.value)}})</span>
                                        <span *ngIf="disabled"><mat-spinner diameter="15"></mat-spinner></span>
                                    </small>
                                    <button mat-icon-button [disabled]="disabled" (click)="removeBasicFilter(filterStructure, i, $event)">
                                        <mat-icon *ngIf="expPanel.expanded">cancel</mat-icon>
                                    </button>
                                </mat-chip>
                                <span *ngIf="!isLastTag" class="selectedSeparator">or</span>
                                </span>
                            </mat-chip-list>
                            </span>
                            <span *ngIf="!filterStructure.get('values').controls.length" style="padding-top: 5px;">No tags selected, select from the list below.</span>
                            <span fxFlex></span>
                            <button mat-icon-button (click)="removeTagGroup(ind, $event)" matTooltip="Remove this set of tags"><mat-icon>cancel</mat-icon></button>
                        </mat-expansion-panel-header>
                        <div *ngIf="(!availableTags || !availableTags.length) && docCount !== 0" fxFlex fxLayoutAlign="center center"><spinner></spinner></div>
                        <tag-picker fxFlex
                                    [basicFilterStructure]="filterStructure" 
                                    [availableTags]="availableTags"
                                    [keyTags]="keyTags"
                                    [docCount]="docCount"
                                    [disabled]="disabled"
                                    (onSelect)="mlst.calcHeight = panelHeaderHeight(mlst.offsetHeight); tagAdded.emit();"></tag-picker>

                    </mat-expansion-panel>
                    <span *ngIf="!isLastGroup" class="groupSeparator">AND</span>
                </span>
            </mat-accordion>
        </div>
    `
})
export class BasicFilterEditorComponent implements OnChanges {
    @Input() basicFilterStructures: FormArray;
    @Input() availableTags;
    @Input() keyTags;
    @Input() docCount;
    @Input() disabled;
    @Output() tagAdded = new EventEmitter(); 
    @Output() tagRemoved = new EventEmitter();
    @Output() tagGroupRemoved = new EventEmitter();
    @Output() tagGroupOpened = new EventEmitter();

    tagDefs;
    tagMap: any;
    initialized: boolean;

    constructor(itemService: ItemService) {
        this.tagDefs = itemService.tagDefs;
    }

    panelHeaderHeight(wrapperHeight): string {
        return wrapperHeight + 40 + 'px';
    }

    conditionLabel(curVal, index): string {
        const prefix = index > 0 ? 'and ' : '';
        return `${prefix}include any of these`;
    }

    cancelBubble($event): void {
        $event.cancelBubble = true;
    }

    removeTagGroup(index, $event): void {
        if (!this.disabled) {
            this.basicFilterStructures.removeAt(index);
            $event.cancelBubble = true;
            this.tagGroupRemoved.emit();
        }
    }

    tagLabel(tag): string {
        return _.replace(tag.get('key').value, /_/g, ' ');
    }

    tagCountFor(tag): string {
        return this.tagMap && this.tagMap[`${tag.key}_${tag.type}`] ? this.tagMap[`${tag.key}_${tag.type}`].doc_count : '0';
    }

    tagMapEmpty(): boolean {
        return _.isEmpty(this.tagMap);
    }

    removeBasicFilter(filterStructure, index, $event): void {
        if (!this.disabled) {
            let basicFilterStructures = <FormArray> filterStructure.get('values');
            basicFilterStructures.removeAt(index);
            $event.cancelBubble = true;
            this.tagRemoved.emit();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.availableTags) {
            this.initialized = true;
            this.tagMap = _.keyBy(changes.availableTags.currentValue, tag => `${tag.key}_${tag.type}`)
        }
    }
}